/**
 * Site chrome: header, auth, footer, error pages and shared modals
 */
export const SITE_CHROME = {
  account: 'Account',
  signIn: 'Sign in',
  loggedInAs: (email: string) => `Logged in ${email}`,
  cart: 'Cart',
  tickets: 'Tickets',
  connectWithUs: 'Connect With Us',
  contactSupport: 'Contact Support',
  getMeOutOfHere: 'Get me out of here',
  print: 'Print',
  reportIssue: 'Report an issue',
  skipToContent: 'Skip to content',
  termsOfService: 'Terms of Service',
}

/**
 * Events list and event details pages
 */
export const EVENTS_PAGE = {
  events: 'Events',
  newsletterSignup: 'Newsletter Signup',
  viewAll: 'View all',
  music: 'Music',
  community: 'Community',
  searchPlaceholder: 'Search...',
  upcoming: 'Upcoming',
  recentlyAnnounced: 'Recently Announced',
  ages: 'Ages:',
  faq: 'FAQ',
  clickHere: 'Click Here',
  relatedEvents: 'Related Events',
  guestActs: 'Guest Acts:',
  buyTickets: 'Buy Tickets',
  onSale: (date: string) => `On Sale ${date}`,
  withSupportingActs: (isPlural: boolean) => `With supporting ${isPlural ? 'acts' : 'act'}`,
}
